import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import MiniLoading from '../MiniLoading'
import no from '../../Assets/Images/Login/no.svg'
import Journal from '../../Assets/Images/Clients/journal.svg'
import FlatPoints from '../../Assets/Images/Clients/flat_points.svg'
import './customerInfo.css'
import { t } from 'i18next'
import {
  fetchCustomerById,
  fetchPaintingHistoryByCustomerId,
} from 'redux/actions/clientsActions'
import { fetchSearchSalesDocuments } from 'redux/actions/cotizacionActions'
import { getPuntosGordosByClient } from 'redux/actions/puntosGordosActions'
import { customerTypeId, documentTypeId } from 'Utils/constants'
import JournaCredit from '../../Assets/Images/Cotizacion/book-money.png'
import Palette from '../../Assets/Images/palette2.png'
import { CustomerContext } from 'state/context/CustomerFormContext'
import { AddressOption } from 'Components/ActionTable/components/AddressOption'
import { FormatedDate } from 'Utils/functions'

function CustomerInfo({
  handleOpen,
  open,
  customerId,
  setCustomerId,
  inModal,
  handleOpenEditAddress,
  refreshCustomerInfo,
  setShowCreditAccounts,
  showCreditAccounts,
}) {
  const ADDRESS_PER_PAGE = 6
  const { getCreditAccounts, hasCreditAccounts } = CustomerContext()
  const openRef = useRef(null)
  const paintHistoryContainerRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [customer, setCustomer] = useState(null)
  const [addressNumber, setAddressNumber] = useState(ADDRESS_PER_PAGE)
  const [puntosGordos, setPuntosGordos] = useState(0)
  const [puntosGordosAmount, setPuntosGordosAmount] = useState(0)
  const [numberOfQuotes, setNumberOfQuotes] = useState(0)
  const [showPaintHistory, setShowPaintHistory] = useState(false)
  const [paintHistory, setPaintHistory] = useState([])
  const [paintHistoryPage, setPaintHistoryPage] = useState(1)
  const [paintHistoryLoading, setPaintHistoryLoading] = useState(false)
  const [hasMorePaintHistory, setHasMorePaintHistory] = useState(true)

  const dispatch = useDispatch()

  const companyId = useSelector(state => state.company.CompanyId)

  const hasMoreAddress =
    customer?.AddressList?.length > ADDRESS_PER_PAGE &&
    addressNumber < customer?.AddressList?.length

  // CLOSE
  const closeBar = () => {
    handleOpen(false)
    setShowCreditAccounts(false)
  }

  // FETCH CUSTOMER INFO
  const fetchCustomer = async () => {
    setLoading(true)
    const customerData = await dispatch(fetchCustomerById(customerId, true))
    if (customerData) {
      setCustomer(customerData)
      fetchPuntosGordos(customerData.CustomerInfo?.CustomerId)
      fetchCotizaciones(customerData.CustomerInfo?.CustomerId)
    }
    setLoading(false)
  }

  const fetchCotizaciones = async id => {
    const payload = {
      CompanyId: companyId,
      DocumentTypeId: documentTypeId.QUOTATION,
      customerId: id,
      PageNumber: 1,
      PageSize: 1,
    }
    const cotizacionByClient = await dispatch(
      fetchSearchSalesDocuments(payload)
    )
    if (cotizacionByClient.length > 0) {
      setNumberOfQuotes(cotizacionByClient[0].TotalRegisters)
    }
  }

  // FETCH CUSTOMER PUNTOS GORDOS
  const fetchPuntosGordos = async id => {
    const puntosGordos = await dispatch(getPuntosGordosByClient(id))
    if (puntosGordos) {
      setPuntosGordos(puntosGordos.points)
      setPuntosGordosAmount(puntosGordos.amount)
    }
  }

  const handlePaintingHistory = async (id, pageNumber = 1, append = false) => {
    if (paintHistoryLoading) return

    setPaintHistoryLoading(true)
    const payload = {
      CustomerId: id,
      PageNumber: pageNumber,
      PageSize: 10,
    }
    const response = await dispatch(fetchPaintingHistoryByCustomerId(payload))

    if (response && response.length > 0) {
      const totalRecords =
        response[0].TotalVariant || response[0].TotalRegisters || 0

      if (append) {
        setPaintHistory(prev => [...prev, ...response])
      } else {
        setPaintHistory(response)
      }

      const loadedCount = append
        ? paintHistory.length + response.length
        : response.length
      setHasMorePaintHistory(loadedCount < totalRecords)
      setPaintHistoryPage(pageNumber)
    }

    setPaintHistoryLoading(false)
  }

  const handlePaintHistoryClick = () => {
    setShowPaintHistory(!showPaintHistory)
  }

  const handlePaintHistoryScroll = e => {
    const container = e.target
    const scrollTop = container.scrollTop
    const scrollHeight = container.scrollHeight
    const clientHeight = container.clientHeight

    // Detectar si el usuario está cerca del final (50px antes)
    if (
      scrollHeight - scrollTop - clientHeight < 50 &&
      hasMorePaintHistory &&
      !paintHistoryLoading
    ) {
      handlePaintingHistory(customerId, paintHistoryPage + 1, true)
    }
  }

  useEffect(() => {
    if (open) {
      fetchCustomer()
      setAddressNumber(ADDRESS_PER_PAGE)
      setPaintHistoryPage(1)
      setHasMorePaintHistory(true)
      handlePaintingHistory(customerId, 1, false)
    }
  }, [customerId, companyId, open])

  useEffect(() => {
    open && getCreditAccounts(customerId)
  }, [open])

  useEffect(() => {
    if (refreshCustomerInfo) {
      fetchCustomer()
    }
  }, [refreshCustomerInfo])

  return (
    <>
      <div
        className={
          open ? 'customer-info-navbar' : 'customer-info-navbar-closed'
        }
        ref={openRef}>
        {open && (
          <>
            <div className="close-salesman">
              <h2 className="salesman-title">
                {showPaintHistory
                  ? t('CUSTOMER_INFO_T.TITLE_PAINTING_HISTORY')
                  : t('CUSTOMER_INFO_T.CLIENT_DETAIL_LABEL')}
              </h2>
              <img
                data-testid="img-painting-history-close"
                src={no}
                alt="close"
                onClick={() => {
                  closeBar()
                  if (typeof setCustomerId === 'function') setCustomerId(null)
                  setCustomer(null)
                  setShowPaintHistory(false)
                  setPaintHistoryPage(1)
                  setPaintHistory([])
                  setPaintHistoryLoading(false)
                  setHasMorePaintHistory(true)
                }}
              />
            </div>
            <hr />
            {loading ? (
              <MiniLoading />
            ) : showPaintHistory ? (
              <div
                className="customer-info-sidebar-container"
                ref={paintHistoryContainerRef}
                onScroll={handlePaintHistoryScroll}>
                <div className="paint-history-cards-container">
                  {paintHistory.map((paint, index) => (
                    <div key={paint.id || index} className="paint-history-card">
                      <div
                        className="paint-color-box"
                        style={{ backgroundColor: paint.Color }}
                      />
                      <div className="paint-card-content">
                        <div className="paint-info-item">
                          <span className="paint-value-description">
                            {paint.NameProduct}
                          </span>
                        </div>
                        <div className="info-paint-content">
                          <div className="paint-info-item">
                            <span className="paint-value">{paint.Brand}</span>
                          </div>
                          <div className="paint-info-item">
                            <span className="paint-value">
                              {paint.NameVariant}
                            </span>
                          </div>

                          <div className="paint-info-item">
                            <span className="paint-value">{paint.Code}</span>
                          </div>
                          <div className="paint-info-item">
                            <span className="paint-label">
                              {t('CUSTOMER_INFO_T.INOVICE_DATE')}
                            </span>
                            <span className="paint-value">
                              {FormatedDate(paint.CreatedDate, false)}
                            </span>
                          </div>

                          <div className="paint-info-item">
                            <span className="paint-value">{paint.Sku}</span>
                          </div>
                          <div className="paint-info-item">
                            <span className="paint-label">
                              {t('CUSTOMER_INFO_T.QUANTITY')}
                            </span>
                            <span className="paint-value">
                              {paint.Quantity}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  {paintHistoryLoading && (
                    <MiniLoading noMargin={true} align="center" />
                  )}
                </div>
              </div>
            ) : (
              <div
                className="customer-info-sidebar-container"
                data-testid="container-customer-info">
                <div className="customer-info-sidebar-element">
                  <h2 data-testid="text-customer-info-full-name-label">
                    {t('CUSTOMER_INFO_T.FIRST_LAST_NAME_LABEL')}
                  </h2>
                  <p data-testid="text-customer-info-full-name">
                    {customer?.CustomerInfo?.FullName ||
                      customer?.CustomerInfo?.LegalName}
                  </p>
                </div>
                <div className="customer-info-sidebar-element">
                  <h2 data-testid="text-customer-info-identification-label">
                    {t('CUSTOMER_INFO_T.IDENTIFICATION_LABEL')}
                  </h2>
                  <p data-testid="text-customer-info-identification">
                    {customer?.CustomerInfo?.IDNumber ||
                      customer?.CustomerInfo?.RUC}
                  </p>
                </div>
                {customer?.CustomerInfo?.OperationNoticeNumber && (
                  <div className="customer-info-sidebar-element">
                    <h2 data-testid="text-customer-info-operation-notice-label">
                      {t('SEARCH_CLIENT_T.OPERATION_NOTICE_NUMBER_ACCESOR')}
                    </h2>
                    <p data-testid="text-customer-info-operation-notice">
                      {customer?.CustomerInfo?.OperationNoticeNumber}
                    </p>
                  </div>
                )}

                <div className="customer-info-sidebar-element">
                  <h2 data-testid="text-customer-info-client-code-label">
                    {t('CUSTOMER_INFO_T.CLIENT_CODE')}
                  </h2>
                  <p data-testid="text-customer-info-client-code">
                    {customer?.CustomerInfo?.SystemCode}
                  </p>
                </div>

                <div className="customer-info-sidebar-element">
                  <h2 data-testid="text-customer-info-phone-label">
                    {t('CUSTOMER_INFO_T.PHONE_LABEL')}
                  </h2>
                  <p data-testid="text-customer-info-phone">
                    {customer?.CustomerInfo?.Telephone ||
                      t('CUSTOMER_INFO_T.NO_INFO_LABEL')}
                  </p>
                </div>

                <div className="customer-info-sidebar-element">
                  <h2 data-testid="text-customer-info-mail-label">
                    {t('CUSTOMER_INFO_T.MAIL_LABEL')}
                  </h2>
                  <p data-testid="text-customer-info-mail">
                    {customer?.CustomerInfo?.Email ||
                      customer?.AdministrativeStoreInfo?.EmailList?.[0]
                        ?.EmailInfo?.Address ||
                      t('CUSTOMER_INFO_T.NO_INFO_LABEL')}
                  </p>
                </div>

                <div className="customer-info-sidebar-element">
                  <h2 data-testid="text-customer-info-client-type-label">
                    {t('CUSTOMER_INFO_T.CLIENT_LABEL_TYPE')}
                  </h2>
                  <p data-testid="text-customer-info-client-type">
                    {customer?.CustomerType?.Description}
                  </p>
                </div>

                <div className="customer-info-sidebar-element">
                  <h2 data-testid="text-customer-info-assigned-price-list-label">
                    {t('CUSTOMER_INFO_T.ASSIGNED_PRICE_LIST')}
                  </h2>
                  <p data-testid="text-customer-info-assigned-price-list">
                    {customer?.CustomerInfo?.PriceList
                      ? customer.CustomerInfo?.PriceList.filter(
                          price => price.DefaultList
                        )[0]?.PriceListName ||
                        customer.CustomerInfo?.PriceList[0]?.PriceListName ||
                        t('CUSTOMER_INFO_T.NO_INFO_LABEL')
                      : t('CUSTOMER_INFO_T.NO_INFO_LABEL')}
                  </p>
                </div>
                {paintHistory?.length > 0 && (
                  <button
                    data-testid="btn-painting-history-open"
                    className="paint-history-button"
                    onClick={handlePaintHistoryClick}>
                    <img src={Palette} alt="palette" />
                    <p>{t('CUSTOMER_INFO_T.TITLE_PAINTING_HISTORY')}</p>
                  </button>
                )}

                <div className="customer-info-sidebar-element">
                  <h2 data-testid="text-customer-info-client-directions-label">
                    {t('CUSTOMER_INFO_T.CLIENT_DIRECTIONS_LABEL')}
                  </h2>

                  {customer &&
                  customer.CustomerType?.CustomerTypeId ===
                    customerTypeId.natural ? (
                    <>
                      {!customer?.AddressList && (
                        <p data-testid="text-customer-info-no-address-label">
                          {t('CUSTOMER_INFO_T.NO_INFO_LABEL')}
                        </p>
                      )}
                      <div className="customer-info-sidebar-addresses">
                        {customer?.AddressList?.length > 0 &&
                          customer?.AddressList.slice(0, addressNumber).map(
                            address => (
                              <AddressOption
                                key={address.AddressInfo?.AddressId}
                                address={address}
                                showAddressDetail={handleOpenEditAddress}
                              />
                            )
                          )}
                      </div>
                    </>
                  ) : (
                    <>
                      {!customer?.AdministrativeStoreInfo?.AddressList
                        ?.length && <p>{t('CUSTOMER_INFO_T.NO_INFO_LABEL')}</p>}
                      <div className="customer-info-sidebar-addresses">
                        {customer?.AdministrativeStoreInfo?.AddressList
                          ?.length > 0 &&
                          customer?.AdministrativeStoreInfo?.AddressList.slice(
                            0,
                            addressNumber
                          ).map(address => (
                            <AddressOption
                              key={address.AddressInfo?.AddressId}
                              address={address}
                              showAddressDetail={handleOpenEditAddress}
                            />
                          ))}
                      </div>
                    </>
                  )}
                </div>
                {hasMoreAddress && (
                  <div className="see-more-customer">
                    <p
                      onClick={() =>
                        setAddressNumber(addressNumber + ADDRESS_PER_PAGE)
                      }
                      data-testid="text-customer-info-see-more-address">
                      {t('CUSTOMER_INFO_T.SEE_MORE_LABEL')}
                    </p>
                  </div>
                )}
                <hr />
                <div className="customer-info-extra">
                  <div className="customer-info-extra-element">
                    <img src={FlatPoints} alt="flat_points" />
                    <p data-testid="text-customer-info-flat-points">
                      {puntosGordos.toLocaleString()} = $
                      {puntosGordosAmount.toFixed(2)}
                    </p>
                  </div>
                  {customer?.CustomerInfo?.TierDescription ? (
                    <div className="customer-info-extra-element">
                      <img
                        src={customer?.CustomerInfo?.TierImageUrl}
                        alt="red_pro"
                        width={'90px'}
                        height={'82px'}
                      />
                      <p data-testid="text-customer-info-red-pro">
                        {t('CUSTOMER_INFO_T.REDPRO')}{' '}
                        {customer?.CustomerInfo?.TierDescription}
                      </p>
                    </div>
                  ) : null}
                  <div className="customer-info-extra-element">
                    <img src={Journal} alt="journal" />
                    <p data-testid="text-customer-info-number-of-quotes">
                      {numberOfQuotes}
                    </p>
                  </div>
                  {hasCreditAccounts && (
                    <button
                      onClick={() => setShowCreditAccounts(!showCreditAccounts)}
                      className="customer-info-extra-element actionable">
                      <img
                        className="journal-icons"
                        src={JournaCredit}
                        alt="journal"
                      />
                      <p data-testid="text-customer-info-credit-accounts">
                        Cuentas crédito
                      </p>
                    </button>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  )
}

export default CustomerInfo
